module.exports = __webpack_public_path__ + "static/media/Lesson-10-08-The-God-Who-Shares-his-Patients.2205cc79.pdf";